module.exports = __webpack_public_path__ + "img/img-subscribed@2x.971d87c.jpg";